import { ReadonlyURLSearchParams } from 'next/navigation';

import { User } from '@/store/user/types';

import { getCookie } from './cookies';
import { CALM_USER_ID } from './privacyCookies';

export const getUserIdForAnalytics = (
	user: User | null,
	searchParams: URLSearchParams | ReadonlyURLSearchParams | null,
): string | undefined => {
	if (user?.id) {
		return user.id;
	}

	const queryUserId = searchParams?.get('user_id');
	if (queryUserId) {
		return queryUserId;
	}

	return getCookie(CALM_USER_ID);
};
